// extracted by mini-css-extract-plugin
export default {"btn-powerUp":"PowerUp_btn-powerUp__xjVbY","inactivePowerUp":"PowerUp_inactivePowerUp__CQxSj","img-powerUp":"PowerUp_img-powerUp__5+hjG"};